import { useCallback, useEffect } from "react";
import { chatApi, fetchSetting } from "../../../../services/api";

interface UseRobotSettingsProps {
  code: string;
  setQuickQuestions: React.Dispatch<React.SetStateAction<Bot.QuickQuestion[]>>;
  setRobotSettings: React.Dispatch<
    React.SetStateAction<{
      robotCode?: string;
      openQuickQa?: boolean;
      switchChatEvaluate?: boolean;
      switchTypingHint?: boolean;
      agentAvatarUrl?: string;
    }>
  >;
}

export const useRobotSettings = ({
  code,
  setQuickQuestions,
  setRobotSettings,
}: UseRobotSettingsProps) => {
  // 获取快捷问题
  const fetchQuickQuestions = useCallback(async () => {
    try {
      const response = await chatApi.fetchQuickQuestion(code);
      if (response.success && response.data) {
        setQuickQuestions(response.data);
        console.log("✅ 快捷问题获取成功:", response.data);
      } else {
        console.warn("⚠️ 快捷问题获取失败:", response);
      }
    } catch (error) {
      console.error("❌ 快捷问题获取异常:", error);
    }
  }, [code, setQuickQuestions]);

  // 获取机器人设置
  const fetchRobotSettings = useCallback(async () => {
    try {
      const response = await fetchSetting(code);
      if (response.success && response.data) {
        setRobotSettings(response.data);
        console.log("✅ 机器人设置获取成功:", response.data);
      } else {
        console.warn("⚠️ 机器人设置获取失败:", response);
      }
    } catch (error) {
      console.error("❌ 机器人设置获取异常:", error);
    }
  }, [code, setRobotSettings]);

  // 初始化时获取快捷问题和设置
  useEffect(() => {
    if (code) {
      fetchQuickQuestions();
      fetchRobotSettings();
    }
  }, [fetchQuickQuestions, fetchRobotSettings, code]);

  return {
    fetchQuickQuestions,
    fetchRobotSettings,
  };
};

